'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _themeManager2 = require('../../../../utilities/themeManager');

var _themeManager3 = _interopRequireDefault(_themeManager2);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'social-share';

var renderHeadline = function renderHeadline(headline) {
  if (headline && headline.text) {
    return _react2.default.createElement(
      _heading2.default,
      { level: '2', className: ORGANISM_NAME + '__headline' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph && paragraph.text) {
    return _react2.default.createElement(
      'p',
      {
        className: ORGANISM_NAME + '__paragraph col-xs-12 col-md-10 center-block'
      },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__hatch-text text-xs-center' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var SocialShare = function (_React$Component) {
  _inherits(SocialShare, _React$Component);

  function SocialShare(props) {
    _classCallCheck(this, SocialShare);

    var _this = _possibleConstructorReturn(this, (SocialShare.__proto__ || Object.getPrototypeOf(SocialShare)).call(this, props));

    _this.handleScroll = function () {
      window.removeEventListener('scroll', _this.handleScroll);
      _this.enableImages();
    };

    _this.renderSocialIcons = function (socialIcons) {
      if (socialIcons && socialIcons.length) {
        var renderedSocialIcons = socialIcons.map(function (icon, index) {
          var iconImage = _this.state.showImages && _react2.default.createElement('img', {
            src: icon.logo.src,
            alt: icon.logo.alt,
            className: ORGANISM_NAME + '__icon-image'
          });
          return _react2.default.createElement(
            'a',
            {
              href: icon.logo.href,
              key: index,
              rel: 'noopener noreferrer',
              target: icon.logo.target,
              className: ORGANISM_NAME + '__icon-link',
              'data-pa-click': ORGANISM_NAME + '-Icon' + index + '-' + (icon.logo.alt || 'alt')
            },
            iconImage
          );
        });
        return _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__icons' },
          renderedSocialIcons
        );
      }
      return null;
    };

    _this.state = {
      showImages: false
    };
    return _this;
  }

  _createClass(SocialShare, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          config = _props.config,
          className = _props.className;
      var id = config.id,
          theme = config.theme;

      var _themeManager = (0, _themeManager3.default)({ content: this.props.content }, theme),
          content = _themeManager.content;

      var headline = content.headline,
          paragraph = content.paragraph,
          socialIcons = content.socialIcons,
          hatchText = content.hatchText;


      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME, 'text-xs-center', className, theme);

      return _react2.default.createElement(
        'section',
        {
          id: id,
          className: sectionClasses,
          ref: function ref(el) {
            _this2.sectionElement = el;
          },
          'data-building-block': 'organism'
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-10 col-md-offset-1' },
              renderHeadline(headline),
              renderParagraph(paragraph),
              this.renderSocialIcons(socialIcons),
              renderHatchText(hatchText)
            )
          )
        )
      );
    }
  }]);

  return SocialShare;
}(_react2.default.Component);

exports.default = SocialShare;


SocialShare.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-light', 'theme-background-color-white', 'theme-background-color-blue', 'theme-background-color-dark'])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    socialIcons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      logo: _propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired,
        alt: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string.isRequired,
        target: _propTypes2.default.oneOf(['_self', '_blank'])
      }).isRequired
    })).isRequired,
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string
};

SocialShare.defaultProps = {
  config: {
    theme: 'theme-background-color-light'
  },
  content: {
    headline: {
      text: '35 characters maximum'
    },
    paragraph: {
      text: '110 characters maximjm of text or words which equal ' + 'no more than 4 lines of copy on mobile devices.'
    },
    socialIcons: [{
      logo: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/merchant-business-small-main/1_linkedin.png',
        alt: 'LinkedIn',
        href: '#',
        target: '_blank'
      }
    }, {
      logo: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/merchant-business-small-main/2_twitter.png',
        alt: 'Twitter',
        href: '#',
        target: '_blank'
      }
    }, {
      logo: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/merchant-business-small-main/3_facebook.png',
        alt: 'Facebook',
        href: '#',
        target: '_blank'
      }
    }, {
      logo: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/merchant-business-small-main/4_Youtube.jpg',
        alt: 'YouTube',
        href: '#',
        target: '_blank'
      }
    }],
    hatchText: {
      text: '34 characters maximum per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/social-share/jsx/SocialShare.js
// module id = 1146
// module chunks = 4